module.exports = __webpack_public_path__ + "static/img/slmPurpose1.075fed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmPurpose1.png
// module id = 6H2C
// module chunks = 2